import { Link } from 'react-router-dom';
import Seal from './Seal';
import { contact } from '../content/data';
import { useHasNews } from '../lib/content';
import { T } from '../lib/text';

export default function Footer() {
  const hasNews = useHasNews();
  return (
    <footer className="velvet bg-ink2 text-[#93A6C9] text-[14.5px] pb-8">
      <div className="gold-braid opacity-70" aria-hidden />
      <div className="wrap pt-16">
        <div className="grid gap-9 pb-11 border-b border-white/10 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.4fr]">
          <div>
            <Link to="/" className="flex items-center gap-3" aria-label="FAEMSE home">
              <Seal slot="footer" label="Footer logo" size={40} />
              <span className="font-disp font-bold text-[26px] text-white tracking-wide">
                FA<b className="gold-text">EMS</b>E
              </span>
            </Link>
            <p className="mt-4 max-w-[300px] text-[#7C90B6]">
              <T id="footer.about.a">The</T> {contact.legalName} <T id="footer.about.b">— a</T> {contact.taxStatus}{' '}
              <T id="footer.about.c">fostering excellence in EMS education and training.</T>
            </p>
            <div className="flex gap-2.5 mt-4">
              <a
                href={contact.facebook}
                aria-label="Facebook"
                className="w-11 h-11 rounded-xl bg-white/5 grid place-items-center hover:bg-brand-golddeep transition-colors"
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="#fff">
                  <path d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-2.9h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6v1.9h2.8L16 14.9h-2.4v7A10 10 0 0 0 22 12z" />
                </svg>
              </a>
              <a
                href={contact.linkedin}
                aria-label="LinkedIn"
                className="w-11 h-11 rounded-xl bg-white/5 grid place-items-center hover:bg-brand-golddeep transition-colors"
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="#fff">
                  <path d="M4.98 3.5A2.5 2.5 0 1 1 0 3.5a2.5 2.5 0 0 1 4.98 0zM0 8h5v16H0V8zm7.5 0H12v2.2h.1c.6-1.1 2.1-2.3 4.3-2.3 4.6 0 5.5 3 5.5 6.9V24h-5v-7.3c0-1.7 0-4-2.4-4s-2.8 1.9-2.8 3.8V24H7.5V8z" />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h2 className="font-disp font-semibold text-white text-[15px] tracking-[0.2em] uppercase mb-4">
              <T id="footer.col.association">Association</T>
            </h2>
            <ul className="space-y-2.5">
              <li><Link className="hover:text-white" to="/about"><T id="footer.link.about">About FAEMSE</T></Link></li>
              <li><Link className="hover:text-white" to="/board"><T id="footer.link.board">Board of Directors</T></Link></li>
              <li><Link className="hover:text-white" to="/bylaws"><T id="footer.link.bylaws">Bylaws &amp; elections</T></Link></li>
              <li><Link className="hover:text-white" to="/sponsors"><T id="footer.link.sponsors">Sponsors</T></Link></li>
              <li><Link className="hover:text-white" to="/foundation"><T id="footer.link.foundation.page">Foundation</T></Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-disp font-semibold text-white text-[15px] tracking-[0.2em] uppercase mb-4">
              <T id="footer.col.visit">Visit</T>
            </h2>
            {/* Public pages only: the members-only features live in the portal,
                and "Member benefits" tells visitors what they are (board,
                2026-10-20). News appears once a post exists, as in the header. */}
            <ul className="space-y-2.5">
              <li><Link className="hover:text-white" to="/events"><T id="footer.link.events">Events</T></Link></li>
              {hasNews && <li><Link className="hover:text-white" to="/news"><T id="footer.link.news">News</T></Link></li>}
              <li><Link className="hover:text-white" to="/programs"><T id="footer.link.programs">Program map</T></Link></li>
              <li><Link className="text-brand-goldsoft font-semibold hover:text-white" to="/membership"><T id="footer.link.benefits">Member benefits</T></Link></li>
              <li><Link className="hover:text-white" to="/contact"><T id="footer.link.contact">Contact</T></Link></li>
            </ul>
          </div>
          <div>
            <h2 className="font-disp font-semibold text-white text-[15px] tracking-[0.2em] uppercase mb-4">
              <T id="footer.col.contact">Get in touch</T>
            </h2>
            <p className="text-[#7C90B6] mb-2">{contact.address}</p>
            <Link className="text-brand-bluesoft hover:text-white font-semibold" to="/contact">
              <T id="footer.contact.form">Send us a message</T>
            </Link>
          </div>
        </div>
        <div className="flex flex-wrap justify-between gap-2.5 pt-6 text-[13px] text-[#7C90B6]">
          <span>
            © {new Date().getFullYear()} {contact.legalName} · <T id="footer.copy.city">St. Petersburg, FL</T>
          </span>
          <span>
            <Link className="hover:text-white" to="/privacy"><T id="footer.link.privacy">Privacy</T></Link>
            {' · '}
            <Link className="hover:text-white" to="/terms"><T id="footer.link.terms">Terms</T></Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
